import { useEffect, useState } from "react";
import DeviceScreenLayout from "../components/layouts/DeviceScreenLayout";
import Header from "../components/layouts/Header";
import liquidOrbitVideo from "../assets/animations/liquid-orbit.mp4";
// import { useAuth } from "../contexts/AuthContext";

const LiquidOrbitVideo = () => {
    return (
        <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '100%',
            height: '100%',
        }}>
            <video
                src={liquidOrbitVideo}
                autoPlay
                loop
                muted
                playsInline
                preload="auto"
                style={{
                    height: 600,
                    objectFit: 'contain',
                }}
            />
        </div>
    );
};








// const DebugOverlay = () => {
//     const { selectedStore, selectedChannel, selectedDevice, virtualNumber } = useAuth();
//     return (
//         <div style={{
//             position: 'absolute',
//             top: 12,
//             left: 12,
//             zIndex: 100,
//             background: 'rgba(0,0,0,0.55)',
//             color: '#fff',
//             fontFamily: 'monospace',
//             fontSize: 11,
//             borderRadius: 8,
//             padding: '8px 12px',
//             lineHeight: 1.7,
//             pointerEvents: 'none',
//         }}>
//             <div>device: {selectedDevice?.serial_key ?? '—'}{selectedDevice?.alias ? ` (${selectedDevice.alias})` : ''}</div>
//             <div>store: {selectedStore?.uuid ?? '—'}</div>
//             <div>virtual number: {virtualNumber ?? '—'}</div>
//             <div>channel: {selectedChannel?.uuid ?? '—'}</div>
//         </div>
//     );
// };

// 수화기 끊기 아이콘
const HangUpIcon = () => (
    <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
        <path d="M6.6 10.8c1.4 2.8 3.8 5.1 6.6 6.6l2.2-2.2c.3-.3.7-.4 1-.2 1.1.4 2.3.6 3.6.6.6 0 1 .4 1 1V20c0 .6-.4 1-1 1C10.6 21 3 13.4 3 4c0-.6.4-1 1-1h3.5c.6 0 1 .4 1 1 0 1.3.2 2.5.6 3.6.1.3 0 .7-.2 1L6.6 10.8z" fill="white"/>
    </svg>
);

const HangUpButton = ({ onHangUp }) => (
    <div style={{
        position: 'absolute',
        bottom: 60,
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 10,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 12,
    }}>
        <span style={{
            color: '#FFFFFF',
            fontSize: 15,
            fontFamily: 'Pretendard, sans-serif',
            fontWeight: 600,
            letterSpacing: '-0.3px',
            textShadow: '0 1px 6px rgba(0,0,0,0.4)',
        }}>
            통화중입니다
        </span>
        <button
            onClick={onHangUp}
            style={{
                width: 72,
                height: 72,
                borderRadius: '50%',
                background: '#FF3B30',
                border: 'none',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                boxShadow: '0 4px 20px rgba(255,59,48,0.5)',
            }}
        >
            <HangUpIcon />
        </button>
    </div>
);

const AgentPage = () => {
    const [agentStatus, setAgentStatus] = useState('IDLE');

    useEffect(() => {
        window.setAgentStatus = (status) => setAgentStatus(status);
        return () => { delete window.setAgentStatus; };
    }, []);

    const handleHangUp = () => setAgentStatus('IDLE');
    const isOnCall = agentStatus === 'TALKING' || agentStatus === 'RINGING';

    return (
        <DeviceScreenLayout>
            <>
                <div
                    style={{
                        position: 'absolute',
                        // border: '1px solid green',
                        width: '100%',
                        height: '100%',
                        top: 0,
                        left: 0,
                        zIndex: 2,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'end',
                        justifyContent: 'center',
                        // border: '1px solid green',

                    }}

                >
                    {/* 헤더 영역 */}
                    <Header />


                    <div style={{ flex: 1 }}></div>



                </div>


                {/* <DebugOverlay /> */}

                {isOnCall && <HangUpButton onHangUp={handleHangUp} />}

                {/* AI 배경 항목 */}
                <div
                    style={{
                        position: 'absolute',
                        // border: '1px solid green',
                        width: '100%',
                        height: '100%',
                        top: 0,
                        left: 0,
                        zIndex: 0,
                    }}
                >
                    <LiquidOrbitVideo />
                </div>
            </>
        </DeviceScreenLayout>
    )
}

export default AgentPage;